import type { Simplify } from 'type-fest';
import type { AuthenticationSettings } from '../../../../../shared/settings/authentication';
import type { LDAPStrategy } from '../../../../types';

export type AuthenticationSettingsWithPasswords = Simplify<
  Omit<AuthenticationSettings, 'ldap'> & {
    ldap: LDAPStrategy | null;
  }
>;

export enum AuthenticationMode {
  Email = 'Email Address',
  SsoEmail = 'SSO + Email Address',
  Sso = 'SSO Only',
  OAuth = 'OAuth Only',
}
